












































import { defineComponent, PropType } from "@vue/composition-api";
import { TranslateResult } from "vue-i18n";
import { ListFields } from "@/types";
import ValidationProvider from "@/components/ValidationProvider";

export default defineComponent({
  name: "BaseInputRadio",
  components: { ValidationProvider },
  props: {
    name: { type: String, default: "" },
    label: { type: String, default: "" },
    value: { type: [String, Boolean], default: "" },
    options: { type: Array as PropType<ListFields>, required: true },
    rules: { type: [Array, Object, String] as PropType<string[] | Record<string, any> | string>, default: () => [] },
    rulesMessages: { type: Object as PropType<Record<string, string>>, default: () => ({}) },
    validationMode: {
      validator: (value?: string): boolean => {
        return !value || ["aggressive", "passive", "lazy", "eager"].includes(value);
      },
    },
    hint: { type: String as PropType<TranslateResult> },
    hideErrorMessage: { type: Boolean, default: false },
  },
  model: {
    event: "input",
    prop: "value",
  },
  methods: {
    onInput(value: string | boolean) {
      this.$emit("input", value);
    },
    onValidation(...v: any[]) {
      this.$emit("validation", ...v);
    },
  },
});
